<form name="ChangePassword_form" novalidate (ngSubmit)="saveChangePassword()" #ChangePassword_form="ngForm"
    [mustMatch]="['passw', 'conPassword']">
    <div class="modal-header" style="background-color:#f2f2f2">
        <h4 style="padding-top:10px;">Change Password</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
            <span aria-hidden="true" class="close_btn_popup">&times;</span>
        </button>
    </div>
    <div class="modal-body clearfix floating-label-wrappe pad_top_20">
        <div class="col-sm-12 modal_col field">
            <label for="currentpassword"></label>
            <input class="form-control" type="{{inputType}}" id="currentpassword" name="currentpassword" maxlength="15"
                placeholder="Current Password" [(ngModel)]="OldPassword" #currentpassword="ngModel" autofocus
                with-floating-label
                [ngClass]="{ 'is-invalid': currentpassword.invalid && (currentpassword.dirty || currentpassword.touched) }"
                required />
            <div *ngIf="currentpassword.invalid && (currentpassword.dirty || currentpassword.touched)"
                class="invalid-feedback">
                <div *ngIf="currentpassword.errors?.required">Password is required</div>
            </div>
        </div>
        <div class="col-sm-12 modal_col field">
            <label for="npassword"></label>
            <input class="form-control" type="{{inputType}}" id="npassword" name="passw" placeholder="New Password"
                [(ngModel)]="password" #passw="ngModel" pattern='^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$'
                [ngClass]="{ 'is-invalid': passw.invalid && (passw.dirty || passw.touched) }" with-floating-label
                required />
            <div *ngIf="passw.invalid && (passw.dirty || passw.touched)" class="invalid-feedback">
                <div *ngIf="passw.errors?.required">New Password is required</div>
                <div *ngIf="passw.errors?.pattern">1 numeric, upper & lowercase required</div>
            </div>

        </div>
        <div class="col-sm-12 modal_col field">
            <label for="npassword"></label>
            <input type="{{inputType}}" id="conPassword" name="conPassword" placeholder="Confirm New Password"
                [(ngModel)]="confirmPassword" #conPassword="ngModel" class="form-control"
                [ngClass]="{ 'is-invalid': conPassword.invalid && (conPassword.dirty || conPassword.touched) }"
                with-floating-label required />
            <div *ngIf="conPassword.invalid && (conPassword.dirty || conPassword.touched)" class="invalid-feedback">
                <div *ngIf="conPassword.errors.required">Retype Password is required</div>
                <div *ngIf="conPassword.errors.mustMatch">Password do not match!</div>
            </div>
        </div>

        <div class="col-sm-12 modal_col clearfix">
            <!-- checkboxstyle -->
            <div class="checkboxstyle">
                <input type="checkbox" id="setddefault" name="chracters" value="option2" [(ngModel)]="passwordCheckbox"
                    (click)="hideShowPassword()" /> &nbsp;
                <label for="setddefault">{{(passwordCheckbox) ? 'Hide password' : 'Show password'}}</label>
            </div>
            <!-- end checkboxstyle -->
            <!-- <label for="checkbox" class="chkbox_label" (click)="hideShowPassword()" > {{(passwordCheckbox) ? 'Hide password' : 'Show password'}}</label> -->
            <!-- <label for="checkbox" class="chkbox_label" *ngIf="!passwordCheckbox">Show password</label> -->
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-danger" data-dismiss="modal">Change Password</button>
    </div>
</form>